"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AtLeastOneAdultPerVehicle = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_validator_1 = require("class-validator");
let AtLeastOneAdultPerVehicle = class AtLeastOneAdultPerVehicle {
    validate(value, validationArguments) {
        const { vehicles, passengers, type } = validationArguments.object;
        if (type !== legacy_enums_1.OrderType.Private) {
            return true;
        }
        const allAdults = passengers.filter((p) => p.type !== legacy_enums_1.PassengerType.Child);
        return allAdults.length >= vehicles.length;
    }
    defaultMessage() {
        return "At least one adult passenger is required per vehicle.";
    }
};
exports.AtLeastOneAdultPerVehicle = AtLeastOneAdultPerVehicle;
exports.AtLeastOneAdultPerVehicle = AtLeastOneAdultPerVehicle = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "At least one adult passenger is required per vehicle." })
], AtLeastOneAdultPerVehicle);
//# sourceMappingURL=AtLeastOneAdultPerVehicle.js.map